import React from "react";
import toast from "react-hot-toast";
import Button from "../common/Button";
import { toastOptions } from "../common/toastOptions";

interface BackupCodesDisplayProps {
  codes: string[];
  onContinue: () => void;
}

const BackupCodesDisplay: React.FC<BackupCodesDisplayProps> = ({
  codes,
  onContinue,
}) => {
  const handleCopyAll = () => {
    navigator.clipboard.writeText(codes.join("\n"));
    toast.success("Backup codes copied to clipboard", toastOptions);
  };

  const handleDownload = () => {
    const text = `Police Narratives AI - Backup Recovery Codes\n${"=".repeat(45)}\n\nStore these codes in a safe place. Each code can only be used once.\n\n${codes.map((c, i) => `${i + 1}. ${c}`).join("\n")}\n\nGenerated: ${new Date().toLocaleString()}`;
    const blob = new Blob([text], { type: "text/plain" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "pn-backup-codes.txt";
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="space-y-4">
      <div className="bg-yellow-50 dark:bg-amber-950/40 border border-yellow-200 dark:border-amber-900 rounded-lg p-4">
        <p className="text-sm text-yellow-800 dark:text-amber-400 font-medium">
          Save these backup codes in a safe place. Each code can only be used
          once to access your account if you lose your primary MFA method.
        </p>
      </div>

      <div className="grid grid-cols-2 gap-2 bg-base-200 rounded-lg p-4 font-mono text-sm">
        {codes.map((code, index) => (
          <div key={index} className="py-1 px-2">
            <span className="text-base-content/40 mr-2">{index + 1}.</span>
            {code}
          </div>
        ))}
      </div>

      <div className="flex gap-2 justify-center">
        <Button variant="secondary" onClick={handleCopyAll} size="sm">
          Copy All
        </Button>
        <Button variant="secondary" onClick={handleDownload} size="sm">
          Download
        </Button>
      </div>

      <Button variant="primary" onClick={onContinue} className="w-full">
        I've saved my backup codes
      </Button>
    </div>
  );
};

export default BackupCodesDisplay;
